// ============================================================================
// React & Dependencies
// ============================================================================
import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'

// ============================================================================
// Contexts & Layout
// ============================================================================
import AuthContext from './contexts/AuthContext'
import { Layout } from './layout'

// ============================================================================
// Pages - Authentication
// ============================================================================
import { LoginPage } from './pages/auth'

// ============================================================================
// Pages - Home
// ============================================================================
import { HomePage } from './pages/home'

// ============================================================================
// Pages - Events
// ============================================================================
import { EventsPage, CreateEventPage, EditEventPage } from './pages/events'

// ============================================================================
// Pages - Participants
// ============================================================================
import {
  ParticipantPage,
  CreateParticipantPage,
} from './pages/participants'

// ============================================================================
// Pages - Activities & Logs
// ============================================================================
import { ActivitiesPage } from './pages/activities'
import { LogsPage } from './pages/logs'

// ============================================================================
// Pages - Users
// ============================================================================
import { UsersPage } from './pages/users'

// ============================================================================
// Pages - Stats & Stocks
// ============================================================================
import { StatsPage } from './pages/stats'
import { StockPage } from './pages/stocks'

// ============================================================================
// Pages - Other
// ============================================================================
import IdcardReaderPage from './pages/IdcardReaderPage'

// ============================================================================
// Main App Component
// ============================================================================
const App = () => {
  const { user } = useContext(AuthContext)

  
  if (!user) {
    return <LoginPage />
  }

  return (
    <Layout>
      <Routes>
        {/* ====================================================================
            Authentication Routes
            ==================================================================== */}

        {/* ====================================================================
            Home Routes
            ==================================================================== */}
        <Route path="/home" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />

        {/* ====================================================================
            Event Routes
            ==================================================================== */}
        <Route path="/events" element={<EventsPage />} />
        <Route path="/event/create" element={<CreateEventPage />} />
        <Route path="/event/:eventId/edit" element={<EditEventPage />} />
        <Route path="/event/:eventId" element={<ParticipantPage />} />

        {/* ====================================================================
            Participant Routes
            ==================================================================== */}
        <Route path="/event/:eventId/participant" element={<ParticipantPage />} />
        <Route path="/event/:eventId/participant/add" element={<CreateParticipantPage />} />

        {/* ====================================================================
            Stats & Stock Routes
            ==================================================================== */}
        <Route path="/event/:eventId/stats" element={<StatsPage />} />
        <Route path="/event/:eventId/stock" element={<StockPage />} />

        {/* ====================================================================
            Activity & Log Routes (Admin only - enforced inside each page)
            ==================================================================== */}
        <Route path="/event/:eventId/activity" element={<ActivitiesPage />} />
        <Route path="/event/:eventId/logs" element={<LogsPage />} />
        <Route path="/logs" element={<LogsPage />} />

        {/* ====================================================================
            User Routes
            ==================================================================== */}
        <Route path="/users" element={<UsersPage />} />

        {/* ====================================================================
            Other Routes
            ==================================================================== */}
        <Route path="/demo/idcard" element={<IdcardReaderPage />} />
      </Routes>
    </Layout>
  )
}

export default App
